module.exports = __webpack_public_path__ + "img/Archiv_2021.98f1a148.jpeg";